"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedgiftsm = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedgiftsm` : '') + (description ? ` desc-brandedgiftsm` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedgiftsm"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedgiftsm"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M4.4 8h16v11a1 1 0 0 1-1 1h-14a1 1 0 0 1-1-1V8Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.85 4.92A6.15 6.15 0 0 0 9.4 3.6a.64.64 0 0 0-.6 1.13 6.15 6.15 0 0 0 2.27.48 2 2 0 0 0-.23-.3Zm.51.84v-.02.02Zm.3-.6h.02-.01Zm.98.9c.52-.98-1.62-3.13-2.6-3.65a2 2 0 0 0-1.87 3.53c.97.52 3.95 1.09 4.47.11Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.95 4.92A6.15 6.15 0 0 1 15.4 3.6a.64.64 0 0 1 .6 1.13 6.15 6.15 0 0 1-2.27.48 2 2 0 0 1 .23-.3Zm-.51.84v-.02.02Zm-.3-.6h-.02.01Zm-.98.9c-.52-.98 1.62-3.13 2.6-3.65a2 2 0 0 1 1.87 3.53c-.97.52-3.95 1.09-4.47.11Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M3.4 7a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-16a1 1 0 0 1-1-1V7Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4 11h-16v-1h16v1Z",
    fill: "#E35200"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.4 6h4v4h-4V6Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.4 8h4v12h-4V8Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4 11h-4v-1h4v1Z",
    fill: "#CC0058"
  }));
};
var _default = exports.default = brandedgiftsm;